module.exports = __webpack_public_path__ + "img/bg.2c0b71ae.png";